function initAccordion(accordion) {
  const items = accordion.querySelectorAll(':scope > li');

  items.forEach(item => {
    const input = item.querySelector('input[type="checkbox"], input[type="radio"]');
    
    if (input === null) {
      return;
    } 
    onChange(item, accordion);

    input.addEventListener('change', () => onChange(item, accordion));

    setWidths(item);

    window.addEventListener('resize', () => setWidths(item));

    const content = item.querySelector('.accordion__content');

    if (accordion.classList.contains('toggle-hover')) {
      item.addEventListener('mouseenter', () => {
        onChange(item, accordion, true);

        if (content.classList.contains('header-overlay-disabled')) {
          window.softToggleHeaderOverlay();
        }
      });
      item.addEventListener('mouseleave', (e) => {
        onChange(item, accordion, false);

        if (content.classList.contains('header-overlay-disabled')) {
          window.softToggleHeaderOverlay();
        }
      });
    }
  });
}
window.initAccordion = initAccordion;

function setWidths(item) {
  const header = item.querySelector('.accordion__header');
  const content = item.querySelector('.accordion__content');

  if (header && content) {
    content.style.minWidth = header.offsetWidth;
  }
}
function onChange(item, accordion, forceState = null) {
  const input = item.querySelector('.accordion__header input[type="checkbox"], .accordion__header input[type="radio"]');
  const content = item.querySelector('.accordion__content');

  if (input === null) {
    return;
  }

  if (forceState !== null) {
    input.checked = forceState;
  }
  
  const state = (forceState !== null) ? forceState : input.checked;


  // Initialise ARIA attributes
  if (!accordion.classList.contains('seo-display') || accordion.getAttribute('data-initialized') === 'true') {
    if (state) {
      content?.removeAttribute('inert');
    } else {
      content?.setAttribute('inert', '');
    }
    
    input.setAttribute('aria-expanded', state ? 'true' : 'false');
  }

  content?.classList.toggle('active', state);
  const icon = item.querySelector(':scope > .accordion__header .accordion-toggle, :scope > .accordion__header.accordion-toggle');

  if (!accordion.classList.contains('no-icon') && icon !== null) {
    if (accordion.classList.contains('chevron-horizontal') || content?.classList.contains('chevron-horizontal')) {
      icon.classList.toggle('bi-chevron-right', !state);
      icon.classList.toggle('bi-chevron-left', state);
    } else if (accordion.classList.contains('chevron')) { 
      icon.classList.toggle('bi-chevron-down', !state);
      icon.classList.toggle('bi-chevron-up', state);
    } else {
      icon.classList.toggle('bi-plus-lg', !state);
      icon.classList.toggle('bi-dash-lg', state);
    }
  }

  centreDropdownContent(item);
  accordion.setAttribute('data-initialized', 'true');
}

function centreDropdownContent(accordion) {
  const content = accordion.querySelector('.accordion__content');
  
  if (content && content.classList.contains('align-center')) {
    requestAnimationFrame(() => {
      // Reset left position before recalculating
      content.style.left = '';
      
      const headerRect = accordion.querySelector('.accordion__header').getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      const offset = (headerRect.width / 2) - (contentRect.width / 2);
      
      content.style.left = `${offset + contentRect.left}px`;
    });
  }
}

function setState(accordion, state) {
  const input = accordion.querySelector(':scope > li > .accordion__header input[type="checkbox"], :scope > li > .accordion__header input[type="radio"]');
  if (input) {
    requestAnimationFrame(() => {
      Array.from(accordion.children).forEach(item => { 
        onChange(item, accordion, state);
      });
    });
  }
}
window.setAccordionState = setState;

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.accordion').forEach(accordion => {
    initAccordion(accordion);
  });
});

var resizeTimeoutAccordion;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeoutAccordion);
    resizeTimeoutAccordion = setTimeout(() => {
    document.querySelectorAll('.accordion > li').forEach(accordion => {
      const content = accordion.querySelector('.accordion__content');

      if (content && content.dataset.initialized) {
        delete content.dataset.initialized;
      }

      if (content) {
        centreDropdownContent(accordion);
      }   
    });
  }, 50);
});